import { useResetRecoilState } from 'recoil';
import { accountState } from '../storage/account';
import { pageState, selectWorkspaceState, sidenavIsPinnedState, workspaceState, workspacesState } from '../storage/app';
import { assetsState } from '../storage/assets';
import { activeClientState, currentStatesState } from '../storage/client';
import { availableCommandsState } from '../storage/commands';
import {
  filterGroupState,
  orderDirectionState as orderDirectionCurrentState,
  searchCurrentStateState,
  sortCurrentStateState,
} from '../storage/currentStates';
import {
  editingEventSettingState,
  searchEventSettingsState,
  selectedEventSettingState,
} from '../storage/eventSettings';
import { editingFenceState, fencesState, searchFenceState, selectedFenceIdState } from '../storage/fences';
import {
  allGroupsState,
  editingGroupState,
  groupsState,
  searchGroupState,
  selectedGroupIdState,
} from '../storage/groups';
import {
  editingJourneyState,
  filterStatusState,
  journeySelectPointState,
  journeysState,
  orderDirectionState as orderDirectionJourneysState,
  searchJourneyState,
  selectedJourneyIdState,
  sortJourneysState,
} from '../storage/journeys';
import {
  deliveryFencesGeojsonState,
  fencesGeojsonState,
  mapCurrentStatesState,
  mapDrawModeState,
  mapNewCircleState,
  mapNewFeatureState,
  mapTypeState,
  mapViewState,
  selectedSpotLayerState,
  selectedZoneFenceState,
  showDeliveryFencesLayerState,
  showFencesLayerState,
  showTrafficLayerState,
  spotsGeojsonState,
} from '../storage/map';
import {
  notificationsCursorPageState,
  notificationsState,
  unreadNotificationsCountState,
} from '../storage/notifications';
import { appPermissionState } from '../storage/permissions';
import { editingPlaceState, placesState, searchPlaceState, selectedPlaceIdState } from '../storage/places';
import {
  activeReportRouteState,
  notificationTypesState,
  pathsState,
  reportEndDateState,
  reportFilterGroupState,
  reportHistoricStates,
  reportSelectedAssetIdsState,
  reportStartDateState,
  selectedPathIdState,
} from '../storage/reports';
import {
  editingNotificationSettingsState,
  notificationSettingsState,
  updateNotificationSettingsState,
} from '../storage/settings';
import {
  allSubAccountsState,
  editingSubAccountState,
  selectedSubAccountIdState,
  subAccountsState,
  updateSubAccountsState,
} from '../storage/subAccounts';
import { changeUserPasswordState, editingUserState, selectedUserIdState, usersState } from '../storage/users';
import { internalNotificationTypeState } from './../storage/notifications';

export function useClearStorage() {
  const atomsToReset = [
    useResetRecoilState(accountState),
    useResetRecoilState(activeClientState),
    useResetRecoilState(activeReportRouteState),
    useResetRecoilState(allGroupsState),
    useResetRecoilState(allSubAccountsState),
    useResetRecoilState(appPermissionState),
    useResetRecoilState(assetsState),
    useResetRecoilState(availableCommandsState),
    useResetRecoilState(changeUserPasswordState),
    useResetRecoilState(currentStatesState),
    useResetRecoilState(editingFenceState),
    useResetRecoilState(editingGroupState),
    useResetRecoilState(editingJourneyState),
    useResetRecoilState(editingNotificationSettingsState),
    useResetRecoilState(editingEventSettingState),
    useResetRecoilState(editingPlaceState),
    useResetRecoilState(editingSubAccountState),
    useResetRecoilState(editingUserState),
    useResetRecoilState(fencesGeojsonState),
    useResetRecoilState(deliveryFencesGeojsonState),
    useResetRecoilState(fencesState),
    useResetRecoilState(filterGroupState),
    useResetRecoilState(filterStatusState),
    useResetRecoilState(groupsState),
    useResetRecoilState(journeySelectPointState),
    useResetRecoilState(journeysState),
    useResetRecoilState(mapCurrentStatesState),
    useResetRecoilState(mapDrawModeState),
    useResetRecoilState(mapNewCircleState),
    useResetRecoilState(mapNewFeatureState),
    useResetRecoilState(mapTypeState),
    useResetRecoilState(mapViewState),
    useResetRecoilState(unreadNotificationsCountState),
    useResetRecoilState(notificationsCursorPageState),
    useResetRecoilState(notificationSettingsState),
    useResetRecoilState(notificationsState),
    useResetRecoilState(notificationTypesState),
    useResetRecoilState(internalNotificationTypeState),
    useResetRecoilState(pageState),
    useResetRecoilState(pathsState),
    useResetRecoilState(placesState),
    useResetRecoilState(reportEndDateState),
    useResetRecoilState(reportFilterGroupState),
    useResetRecoilState(reportHistoricStates),
    useResetRecoilState(reportSelectedAssetIdsState),
    useResetRecoilState(reportStartDateState),
    useResetRecoilState(searchCurrentStateState),
    useResetRecoilState(searchFenceState),
    useResetRecoilState(searchGroupState),
    useResetRecoilState(searchJourneyState),
    useResetRecoilState(searchEventSettingsState),
    useResetRecoilState(searchPlaceState),
    useResetRecoilState(selectedFenceIdState),
    useResetRecoilState(selectedGroupIdState),
    useResetRecoilState(selectedJourneyIdState),
    useResetRecoilState(selectedEventSettingState),
    useResetRecoilState(selectedPathIdState),
    useResetRecoilState(selectedPlaceIdState),
    useResetRecoilState(selectedSpotLayerState),
    useResetRecoilState(selectedSubAccountIdState),
    useResetRecoilState(selectedUserIdState),
    useResetRecoilState(selectedZoneFenceState),
    useResetRecoilState(selectWorkspaceState),
    useResetRecoilState(showFencesLayerState),
    useResetRecoilState(showDeliveryFencesLayerState),
    useResetRecoilState(showTrafficLayerState),
    useResetRecoilState(sidenavIsPinnedState),
    useResetRecoilState(orderDirectionCurrentState),
    useResetRecoilState(orderDirectionJourneysState),
    useResetRecoilState(sortCurrentStateState),
    useResetRecoilState(sortJourneysState),
    useResetRecoilState(spotsGeojsonState),
    useResetRecoilState(subAccountsState),
    useResetRecoilState(updateNotificationSettingsState),
    useResetRecoilState(updateSubAccountsState),
    useResetRecoilState(usersState),
    useResetRecoilState(workspacesState),
    useResetRecoilState(workspaceState),
  ];

  const clearStorage = () => {
    atomsToReset.forEach((resetAtom) => resetAtom());
    localStorage.clear();
  };

  return clearStorage;
}
